import React from 'react';
import { useTranslation } from 'react-i18next';
import { useWebSocket } from '../hooks/useWebSocket';

const UpdateNotification = () => {
  const { t } = useTranslation();
  const { notification, clearNotification } = useWebSocket();

  if (!notification) {
    return null;
  }

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleDismiss = () => {
    clearNotification();
  };

  return (
    <div className="fixed top-[var(--app-banner-height,0px)] left-0 right-0 z-[9999] mx-auto max-w-screen-md px-4 pt-4 md:px-0 md:pt-6 animate-[slideDown_0.3s_ease-out]">
      <div className="bg-black border border-gray-800 rounded-lg shadow-lg overflow-hidden">
        <div className="flex items-start gap-4 p-4">
          <div className="flex-shrink-0 w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>

          <div className="flex-1 min-w-0">
            <h3 className="text-white font-semibold text-base mb-1">
              {t('Update available')}
            </h3>
            <p className="text-gray-300 text-sm leading-relaxed">
              {notification.message}
            </p>
          </div>

          <button
            onClick={handleDismiss}
            className="flex-shrink-0 text-gray-500 hover:text-gray-300 transition-colors"
            aria-label={t('Close')}
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="flex gap-2 px-4 pb-4">
          <button
            onClick={handleRefresh}
            className="flex-1 bg-white text-black font-semibold py-2.5 px-4 rounded-md hover:bg-gray-100 transition-colors text-sm"
          >
            {t('Refresh now')}
          </button>
          <button
            onClick={handleDismiss}
            className="flex-1 bg-gray-800 text-white font-medium py-2.5 px-4 rounded-md hover:bg-gray-700 transition-colors text-sm"
          >
            {t('Later')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateNotification;
